import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MAX_COMPARE_PRODUCTS } from '../utils/compareProducts';
import CompareScaleIcon from './CompareScaleIcon';
import './CompareBar.css';

const CompareBar = ({
  items = [],
  onClear,
  onRemoveItem,
}) => {
  const navigate = useNavigate();
  const count = items.length;

  if (count === 0) return null;

  const atMax = count >= MAX_COMPARE_PRODUCTS;

  const handleCompare = () => {
    navigate('/compare');
  };

  return (
    <div className="compare-bar" role="region" aria-label="Product comparison tray">
      <div className="compare-bar-panel">
        <div className="compare-bar-header">
          <div className="compare-bar-title">
            <CompareScaleIcon className="compare-bar-icon" size={18} />
            <span>
              Comparing <strong>{count}</strong> {count === 1 ? 'item' : 'items'}
            </span>
            {atMax && <span className="compare-bar-max">MAX</span>}
          </div>
          <div className="compare-bar-header-actions">
            <button type="button" className="compare-bar-clear" onClick={onClear}>
              Clear all
            </button>
            <button
              type="button"
              className="compare-bar-close"
              onClick={onClear}
              aria-label="Clear comparison"
            >
              ×
            </button>
          </div>
        </div>

        <div className="compare-bar-thumbs">
          {items.map((product) => {
            const productId = product.id || product._id;
            const imageSrc = product.image || product.thumbnail || '';
            const imageKit = product.thumbnailImagekit || product.imagekitImages?.[0] || '';
            const imageFallback = product.thumbnailFallback || product.imageFallbacks?.[0] || '';
            return (
              <div key={productId} className="compare-bar-thumb-wrap">
                <img
                  src={imageSrc}
                  alt=""
                  className="compare-bar-thumb"
                  onError={(e) => {
                    const src = e.currentTarget.src || '';
                    if (imageKit && !/ik\.imagekit\.io/i.test(src) && !/\.blob\.vercel-storage\.com/i.test(src)) {
                      e.currentTarget.src = imageKit;
                      return;
                    }
                    if (imageFallback && !/\.blob\.vercel-storage\.com/i.test(src)) {
                      e.currentTarget.src = imageFallback;
                    }
                  }}
                />
                <button
                  type="button"
                  className="compare-bar-thumb-remove"
                  onClick={() => onRemoveItem?.(productId)}
                  aria-label={`Remove ${product.name} from compare`}
                >
                  ×
                </button>
              </div>
            );
          })}
          {Array.from({ length: MAX_COMPARE_PRODUCTS - count }).map((_, i) => (
            <div key={`empty-${i}`} className="compare-bar-thumb compare-bar-thumb--empty" aria-hidden />
          ))}
        </div>

        <button type="button" className="compare-bar-cta" onClick={handleCompare}>
          Compare {count} {count === 1 ? 'product' : 'products'}
          <span aria-hidden>→</span>
        </button>
      </div>
    </div>
  );
};

export default CompareBar;
